var map = {
	"./anm-card.png": 577,
	"./app-install-icon.webp": 1679,
	"./arrow.png": 578,
	"./btn-blue-m-v2.png": 579,
	"./btn-blue-m.png": 580,
	"./btn-white-m-v2.png": 581,
	"./btn-white-m.png": 582,
	"./dummy-1.png": 583,
	"./eeziepay.svg": 584,
	"./fcl.svg": 585,
	"./fpx-logo.svg": 586,
	"./game-blue.png": 587,
	"./game-img.png": 588,
	"./game-white.png": 589,
	"./global-language.svg": 590,
	"./ifm-logo.svg": 591,
	"./logo-anniversary.png": 592,
	"./logo-christmas.png": 593,
	"./logo-cny-dragon.png": 594,
	"./logo-cny.png": 595,
	"./logo-halloween.png": 596,
	"./logo-merdeka.png": 597,
	"./logo-mooncake.png": 598,
	"./logo-raya.png": 599,
	"./logo-uefa.png": 600,
	"./merchant-logo.png": 94,
	"./modal-bg.jpg": 601,
	"./number-bg.png": 602,
	"./pagcor.svg": 603,
	"./pool-bg.png": 604,
	"./side-bar-bg.png": 605,
	"./tether.svg": 606,
	"./x33-logo-wc.png": 607,
	"./x33-logo.png": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;